import { __rest } from "tslib";
import React from 'react';
import Icon from '@vtblife/uikit-icons';
import Content from './content';
const InputIcon = (_a) => {
    var { placement = 'end', onClick, pointer, dataTest } = _a, icon = __rest(_a, ["placement", "onClick", "pointer", "dataTest"]);
    return (React.createElement(Content, { placement: placement, onClick: onClick, pointer: pointer, dataTest: dataTest },
        React.createElement(Icon, Object.assign({}, icon))));
};
export default InputIcon;
//# sourceMappingURL=icon.js.map